/**
 * useIsMobile Hook
 *
 * Simple hook for responsive detection based on window width.
 */
import { useEffect, useState } from "react";

/** Default mobile breakpoint in pixels */
export const MOBILE_BREAKPOINT = 480;

/**
 * Returns true if the viewport width is less than the specified breakpoint.
 * @param breakpoint - Width threshold in pixels (default: MOBILE_BREAKPOINT)
 */
export function useIsMobile(breakpoint = MOBILE_BREAKPOINT): boolean {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.innerWidth < breakpoint;
    });

    useEffect(() => {
        const handleResize = (): void => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener("resize", handleResize);
        // Check on mount in case SSR hydration differs
        handleResize();

        return (): void => {
            window.removeEventListener("resize", handleResize);
        };
    }, [breakpoint]);

    return isMobile;
}
